import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { Review } from '@df/catalog/review/review';
import { OrdinalPipe } from '@df/ui/display/ordinal.pipe';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { RatingComponent } from '../../../ui/display/rating/rating.component';

export const PRODUCT_REVIEW_MODAL_ID = 'productReviewModal';

@DfModal({
    id: PRODUCT_REVIEW_MODAL_ID,
    position: 'bottom',
    config: () => ({
        width: '100%',
        height: '80vh',
        maxWidth: '100vw',
        modalClass: 'bg-col-w p-a-4',
        position: { bottom: '0' },
        closeOnNavigation: true
    }),
    blockGroup: 'modals',
    priority: 10,
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S']
})
@Component({
    selector: 'product-review-modal',
    templateUrl: './product-review-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule, OrdinalPipe, RatingComponent]
})
export class ProductReviewModalComponent {
    constructor(
        @Optional() private modalRef: ModalRef<ProductReviewModalComponent>,
        @Optional() @Inject(MODAL_DATA) public review: Review
    ) {}

    close() {
        this.modalRef.close();
    }
}
